import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RedliningService } from '../../../core/services/redlining.service';
import { Attachment } from '../../../core/models/classes/attachment';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
})

export class AttachmentComponent implements OnInit {
  source: string = '';
  imgCount: number = 0;
  currentImg: number = 1;
  selectedImages: any[] = [];
  images: any[] = [];
  loading: boolean = true;
  rlAttachment: number = 0;
  selectedRedliningAttachment: Attachment[] = [];
  allimages: any[] = [];

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private RedliningService: RedliningService,
    private _snackBar: MatSnackBar,
    private sanitizer: DomSanitizer
  ) 
  {
    this.rlAttachment = data.sources;
  }

  ngOnInit(): void {
    this.RedliningService.getRedliningAttachments(this.rlAttachment).subscribe({
      next: (at) => {
        if (at.length === 0) {
          this.attachmentLoadError();          
        } 
        else {
          this.retrieveAttachments(at);          
        }
      },
      error: (err) => {
        throw Error(err.Status);
      },
    });
  }

  attachmentLoadError(){
    this.dialog.closeAll();
    this.loading = false;
    this._snackBar.open(
      $localize`An error occurred while retrieving attachment`,
      '',
      {
        duration: 3000,
      }
    );
  }

  retrieveAttachments(at: Attachment[]){
    this.selectedRedliningAttachment = at;
    if (this.selectedRedliningAttachment.length !== 0) {
      for (let item of this.selectedRedliningAttachment) {
        let objectURL = 'data:image/jpeg;base64,' + item.storagePath;
        this.allimages.push(
          this.sanitizer.bypassSecurityTrustUrl(objectURL)
        );
      }
      this.selectedImages = this.allimages;
      if ( this.selectedImages !== undefined) {
        this.imgCount =  this.selectedImages.length;
        this.source = this.selectedImages[0];
      }
    }
  }

  onLoad() {
    this.loading = false;
  }

  nextImage(): void {
    const first = this.selectedImages.indexOf(this.source);
    if (first < this.selectedImages.length - 1) {
      const next = first + 1;
      this.source = this.selectedImages[next];
      this.currentImg = next + 1;
    }
  }

  prevImage(): void {
    const first = this.selectedImages.indexOf(this.source);
    if (this.currentImg !== 1) {
      this.source = this.selectedImages[first - 1];
      this.currentImg = this.currentImg - 1;
    }
  }
}